// extracted by mini-css-extract-plugin
export default {"root":"SignupPage_root__Be9De","header":"SignupPage_header__4tt6C","form-container":"SignupPage_form-container__v9Hx2","footer":"SignupPage_footer__4+bfA"};